import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

const XtraLineCreator = () => {
  const { t } = useTranslation();
  
  return (
    <div>
    <Typography variant="h4" gutterBottom>{t('xtraline')}</Typography>
    </div>
  );
};

export default XtraLineCreator;